import { useHasPermission } from "../../auth/useClaims";

// Area Master (revised 2026-08-13 to branch-wise, see areasApi.js) -
// standard page-wise Create/Edit/View triad, no all-branch check needed
// (server already branch-scopes reads/writes, same as Customers/Products/
// Employees/Vehicles) - NOT the useMasterPermissions all-branch-required
// pattern used for the genuinely global masters (Departments/Holidays/etc).
export const useCanCreateAreas = () => useHasPermission("Area.Create");
export const useCanEditAreas = () => useHasPermission("Area.Edit");
